import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import fetchEditingChannel from 'features/channel/add/thunk/fetchEditingChannel'
import ChannelAdd from 'features/channel/add/ChannelAdd'
import { setBizChannelId } from 'features/channel/add/channelAddSlice'

const ChannelEdit = () => {
  const dispatch = useDispatch()
  const {
    params: { channelId },
  } = useRouteMatch()

  useEffect(() => {
    dispatch(setBizChannelId(channelId))
    dispatch(fetchEditingChannel())
  }, [dispatch, channelId])

  return <ChannelAdd />
}

export default ChannelEdit
